<template>
    <div>
      <q-dialog v-model="show" @input="(val) => $emit('input', val)">
        <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
          <q-header class="bg-primary">
            <q-toolbar>
              <q-toolbar-title>{{this.$gettext('GENERATE_ORDER')}}</q-toolbar-title>
              <q-btn v-close-popup flat round dense icon="close" />
            </q-toolbar>
          </q-header>

        </q-layout>
      </q-dialog>
      <div>
        <q-dialog ref="dialog">
          <q-card class="q-dialog-plugin">
            <q-card-section class="row justify-center">
              <q-icon name="error_outline" color="warning" size="4.5em"></q-icon>
            </q-card-section>
            <q-card-section class="row justify-center q-mx-lg">
              <span class="text-subtitle1 text-weight-medium text-center">
                <translate v-if="groupBillingOrder">GROUPING_NOTICE</translate>
                <translate v-else>WARNING_NO_GROUPING</translate>
              </span>
            </q-card-section>
            <q-card-actions class="justify-center q-pa-md q-my-sm">
              <q-btn
                :label="$gettext('CANCEL')"
                color="grey-7"
                @click="onCancelClick"
                class="q-px-lg"
              />
              <q-btn
                :label="$gettext('OK')"
                color="info"
                @click="onOKClick"
                class="q-px-lg"
              />
            </q-card-actions>
          </q-card>
        </q-dialog>
      </div>
    </div>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'

  @Component({
    name: 'GenerateOrderModal',
    components: {

    },
    props: {
      show: {
        type: Boolean,
        default: false
      }
    }
  })
class GenerateOrderModal extends Vue {
    modalData = {};
    groupBillingOrder = null;

    hide () {
      this.show = false
    }
  }

export default GenerateOrderModal
</script>
  <style lang="stylus" scoped>
  #generator-order-container {
    .q-card {
      height: 65vh;
    }
  }
  </style>
